import type { RegistryEntry } from '../types';

export const alibabaConfigs: Record<string, RegistryEntry> = {
    // Alibaba Wan 3.0 / Wan 3.0 Prime：声画同步 + Seed
    'wan-3.0': {
        options: [
            { key: 'audio', label: 'Audio-Visual Sync', type: 'switch', default: true, group: 'basic' },
            { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'basic' },
        ],
        toProviderOptions: (ui) => ({
            audio: typeof ui.audio === 'boolean' ? ui.audio : true,
            seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
        } as unknown as Record<string, Record<string, any>>),
    },
    'wan-3.0-prime': {
        options: [
            { key: 'audio', label: 'Audio-Visual Sync', type: 'switch', default: true, group: 'basic' },
            { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'basic' },
        ],
        toProviderOptions: (ui) => ({
            audio: typeof ui.audio === 'boolean' ? ui.audio : true,
            seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
        } as unknown as Record<string, Record<string, any>>),
    },
    // Alibaba Wan 2.7 / Wan 2.7 视频编辑：负向词 + Seed + 提示词扩展
    ...Object.fromEntries(
        ['wan-2.7', 'wan-2.7-v2v'].map(id => [id, {
            options: [
                { key: 'negative_prompt', label: 'Negative Prompt', type: 'input', group: 'advanced' },
                { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'advanced' },
                { key: 'prompt_extend', label: 'Prompt Extend', type: 'switch', default: false, group: 'advanced' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                negative_prompt: typeof ui.negative_prompt === 'string' ? ui.negative_prompt : undefined,
                seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
                prompt_extend: typeof ui.prompt_extend === 'boolean' ? ui.prompt_extend : false,
            } as unknown as Record<string, Record<string, any>>),
        } satisfies RegistryEntry])
    ),
    // Alibaba Wan 2.6 Flash：声画同步（影响计费）+ 负向词 + Seed + 提示词扩展 + 镜头类型
    'wan-2.6-flash': {
        options: [
            { key: 'audio', label: 'Audio-Visual Sync', type: 'switch', default: true, group: 'basic' },
            { key: 'negative_prompt', label: 'Negative Prompt', type: 'input', group: 'advanced' },
            { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'advanced' },
            { key: 'prompt_extend', label: 'Prompt Extend', type: 'switch', default: false, group: 'advanced' },
            {
                key: 'shot_type',
                label: 'Shot Type',
                type: 'select',
                options: [
                    { label: 'Single', value: 'single' },
                    { label: 'Multi', value: 'multi' },
                ],
                default: 'multi',
                group: 'advanced',
            },
        ],
        toProviderOptions: (ui) => ({
            audio: typeof ui.audio === 'boolean' ? ui.audio : true,
            negative_prompt: typeof ui.negative_prompt === 'string' ? ui.negative_prompt : undefined,
            seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
            prompt_extend: typeof ui.prompt_extend === 'boolean' ? ui.prompt_extend : false,
            shot_type: typeof ui.shot_type === 'string' ? ui.shot_type : 'multi',
        } as unknown as Record<string, Record<string, any>>),
    },
    // Alibaba HappyHorse 1.0 / 视频编辑：Seed
    ...Object.fromEntries(
        ['happyhorse-1.0', 'happyhorse-1.0-v2v'].map(id => [id, {
            options: [
                { key: 'seed', label: 'Seed', type: 'number', min: 0, max: 2147483647, step: 1, group: 'advanced' },
            ],
            toProviderOptions: (ui: Record<string, any>) => ({
                seed: typeof ui.seed === 'number' && Number.isFinite(ui.seed) ? ui.seed : undefined,
            } as unknown as Record<string, Record<string, any>>),
        } satisfies RegistryEntry])
    ),
};
